<template>
  <li class="accordion__item">
    <div class="accordion__trigger" :class="{ accordion__trigger_active: visible }" @click="open">
      <!-- This slot will handle the title/header of the accordion and is the part you click on -->
      <slot name="accordion-trigger"></slot>
      <div class="active-icon">
        <svg width="26px" height="26px" viewBox="-5 0 16 34">
          <path
            d="M10.625 17.429c0 0.143-0.071 0.304-0.179 0.411l-8.321 8.321c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-0.893-0.893c-0.107-0.107-0.179-0.25-0.179-0.411 0-0.143 0.071-0.304 0.179-0.411l7.018-7.018-7.018-7.018c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l0.893-0.893c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l8.321 8.321c0.107 0.107 0.179 0.268 0.179 0.411z"
          ></path>
        </svg>
      </div>
    </div>

    <transition name="accordion" @enter="start" @after-enter="end" @before-leave="start" @after-leave="end">
      <div class="accordion__content" v-show="visible">
        <ul>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <slot name="accordion-content"></slot>
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  props: {
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['Accordion'],
  data() {
    return {
      index: null,
    };
  },
  computed: {
    visible() {
      if (this.disabled) {
        return false;
      } else {
        return this.Accordion.active.includes(this.index);
      }
    },
  },
  methods: {
    open() {
      if (this.disabled) {
        return;
      }
      if (this.visible) {
        this.Accordion.active.splice(this.Accordion.active.indexOf(this.index), 1);
      } else {
        if (this.Accordion.alwaysOpen) {
          this.Accordion.active.push(this.index);
        } else {
          this.Accordion.active = [this.index];
        }
      }
    },
    forceOpen() {
      if (!this.visible) {
        if (this.Accordion.alwaysOpen) {
          this.Accordion.active.push(this.index);
        } else {
          this.Accordion.active = [this.index];
        }
      }
    },
    start(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    end(el) {
      el.style.height = '';
    },
  },
  created() {
    this.index = this.Accordion.count++;
    if (this.defaultOpen) {
      this.Accordion.active.push(this.index);
    }
  },
};
</script>

<style lang="scss" scoped>
.accordion__item {
  // border-bottom: 1px solid #ebebeb;
  position: relative;
}

.accordion__trigger {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: self-end;

  & .active-icon {
    height: 26px;
    margin: 2px 2px 0;
    & svg {
      transform: rotate(270deg);
      transition: transform 0.3s ease;
      & path {
        fill: #666;
      }
    }
  }
  &.accordion__trigger_active svg {
    transform: rotate(90deg);
  }
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
